import supabase from '../supabaseClient';

export {
  SPECIALIZATION_TO_SERVICE,
  findMatchingClientService,
  SERVICE_TYPE_LABELS,
  canOfferFeedingTherapy,
  clientHasFeedingTherapyService,
  getDefaultBillingServiceType,
  getBillingServiceType,
  resolveBillingServiceType,
  getFeeTypeForBillingService,
  getFeeTypeForSession,
  getBillingRateDate,
  getClientBillingRate,
  isSundayDate,
} from './serviceTypeUtils';

/**
 * Returns true when the reservation fee should reduce the session Amount Paid field.
 * IE / Endorsement: not if the client already had a present session with another
 * therapist of the same specialization (regardless of session type).
 */
export async function shouldApplyReservationFee({
  clientId,
  sessionType,
  therapistId,
  therapistSpecialization,
  excludeAttendanceId = null,
}) {
  if (sessionType !== 'IE' && sessionType !== 'Endorsement') {
    return false;
  }

  try {
    const { data: existingAttendance, error } = await supabase
      .from('session_attendance')
      .select(`
        id,
        session:sessions (
          therapist_id,
          therapist:therapists (
            id,
            specialization
          )
        )
      `)
      .eq('client_id', clientId)
      .eq('status', 'present')
      .neq('session.therapist_id', therapistId);

    if (error) throw error;

    const hasPreviousSessionWithSameSpecialization = existingAttendance?.some(
      (attendance) =>
        attendance.id !== excludeAttendanceId &&
        attendance.session?.therapist?.specialization === therapistSpecialization
    );

    return !hasPreviousSessionWithSameSpecialization;
  } catch (error) {
    console.error('Error checking reservation fee eligibility:', error);
    return true;
  }
}

export function getReservationFeeDeduction(matchingService, applies) {
  if (!applies) return 0;
  return Number(matchingService?.reservation_fee) || 0;
}

export function grossToNetAmountPaid(grossAmount, reservationFeeDeduction) {
  const gross = Number(grossAmount) || 0;
  return Math.max(0, gross - reservationFeeDeduction);
}

export function netToGrossAmountPaid(netAmount, reservationFeeDeduction) {
  const net = Number(netAmount) || 0;
  return net + reservationFeeDeduction;
}
